export default __webpack_public_path__ + "static/media/updateData.04290c99.png";